import { render, staticRenderFns } from "./MatchDetails.vue?vue&type=template&id=ab3f14d8&scoped=true"
import script from "./MatchDetails.vue?vue&type=script&lang=js"
export * from "./MatchDetails.vue?vue&type=script&lang=js"
import style0 from "./MatchDetails.vue?vue&type=style&index=0&id=ab3f14d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3f14d8",
  null
  
)

export default component.exports